import * as actionTypes from './actionTypes';
import { serviceRecoverPassword } from './service';
import { openModal } from '@app/src/commons/modal/state/modals/actions';

const fetchRecoverPasswordRequest = () => ({
  type: actionTypes.FETCH_RECOVER_PASSWORD_REQUEST
});

const fetchRecoverPasswordFailure = (errorMessage: string) => ({
  type: actionTypes.FETCH_RECOVER_PASSWORD_FAILURE,
  errorMessage
});

const fetchRecoverPasswordSuccess = (data) => ({
  type: actionTypes.FETCH_RECOVER_PASSWORD_SUCCESS,
  data
});

export const fetchRecoverPassword = (values, url): Function => {
  return async dispatch => {
    dispatch(fetchRecoverPasswordRequest());
    try {
      const data = await serviceRecoverPassword.getData(values, url);
      dispatch(fetchRecoverPasswordSuccess(data));
      dispatch(openModal('CREATE_RECOVER_PASSWORD_MODAL'));
    } catch (error) {
      dispatch(openModal('ERROR_CREATE_RECOVER_PASSWORD_MODAL'));
      dispatch(fetchRecoverPasswordFailure(error.message));
    }
  }
}
